var spoiler_default = {
  "fontElementMap": "J-zpy",
  "hideText": "EUg7c",
  "onHoverText": "XfDOi",
  "hideBlock": "jf-5Q",
  "smallBlur": "UkxAZ",
  "mediumBlur": "gWmDo",
  "largeBlur": "NP8fm",
  "hideBlock_gallery": "lzBpn",
  "overlay": "jdkRH",
  "overlay_gallery": "_5DnT3",
  "revealSpoilerBtn": "j77gR",
  "isMobile": "w-qrc",
  "onHoverBtn": "KiqoX",
  "spoilerWrapper": "NnPQt",
  "spoilerDescription": "RgybM",
  "spoilerContainer": "TSAx7",
  "spoilerContainer_Gallery": "b3gcf"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
